import { HomeComponent } from './home/home.component';
import { SelectThirdComponent } from './select-third/select-third.component';
import { AuthGuard } from '@/auth/guard/auth.guard';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';
import { SelectLicenseComponent } from './select-license/select-license.component';
import { FormComponent } from './form/form.component';
import { ResultComponent } from './result/result.component';

export const renewChildRoutes: RouteWithGuardData[] = [
  {
    path: 'third/select',
    component: SelectThirdComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE RENEW THIRD_CONTRACTOR',
        'LICENSE RENEW THIRD_EMPLOYEE',
      ],
    },
  },
  {
    path: 'select-license',
    component: SelectLicenseComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE RENEW PERSONAL_CONTRACTOR',
        'LICENSE RENEW PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: 'select-license/:ofuscatedData',
    component: SelectLicenseComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE RENEW THIRD_CONTRACTOR',
        'LICENSE RENEW THIRD_EMPLOYEE',
      ],
    },
  },
  {
    path: 'form',
    component: FormComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE RENEW THIRD_CONTRACTOR',
        'LICENSE RENEW THIRD_EMPLOYEE',
        'LICENSE RENEW PERSONAL_CONTRACTOR',
        'LICENSE RENEW PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: 'result/:ofuscatedData',
    component: ResultComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE RENEW THIRD_CONTRACTOR',
        'LICENSE RENEW THIRD_EMPLOYEE',
        'LICENSE RENEW PERSONAL_CONTRACTOR',
        'LICENSE RENEW PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: '', // child route path
    component: HomeComponent, // child route component that the router renders
  },
];
